import React, { useEffect, useState } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { useParams } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import { colorTheme } from 'theme';
import Avatar from '@mui/material/Avatar';
import { type IReuseGridProps } from 'types';
import { getEmployeeDetailsByUserId } from 'service';
import { strings } from 'i18n/Strings';
import { dateFormat } from 'utils/GeneralUtil';
import { getResource } from 'service/UserService';

interface IEmployeeInfo {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  designation: string;
  location: string;
  department: string;
  employeeId: string;
  startDate: string;
  endDate: string;
  profileImage: string;
}

interface Response {
  details: IEmployeeInfo;
}

const PersonalDetails = (): JSX.Element => {
  const theme = useTheme();
  const colors = colorTheme(theme.palette.mode);
  const [employeeInfo, setEmployeesInfo] = useState<IEmployeeInfo>();
  const [image, setImage] = useState('');
  const { id } = useParams();

  const getEmployeesData = async (): Promise<void> => {
    try {
      const response = (await getEmployeeDetailsByUserId(
        id as string,
      )) as Response;
      setEmployeesInfo(
        response?.details as unknown as IEmployeeInfo | undefined,
      );
      if (response?.details?.profileImage) {
        const profilePicSignedUrl = await getResource(
          response.details.profileImage,
        );
        if (profilePicSignedUrl.url) setImage(profilePicSignedUrl.url);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (id) {
      void getEmployeesData();
    }
  }, []);

  const ReuseGrid = (props: IReuseGridProps): JSX.Element => (
    <Grid item xs={12} sm={12} md={12} sx={{ display: 'flex', padding: 1 }}>
      <Grid item xs={4} sm={4} md={4}>
        <Typography
          component="h5"
          variant="h5"
          color="#838383"
          fontWeight={700}
          fontSize={16}
          fontFamily="Inter !important"
        >
          {props.customName}
        </Typography>
      </Grid>
      <Grid item xs={4} sm={4} md={4}>
        <Typography>:</Typography>
      </Grid>
      <Grid item xs={4} sm={4} md={4}>
        <Typography
          component="h5"
          variant="h5"
          color={colors.gray[100]}
          fontWeight={700}
          fontSize={16}
          fontFamily="Inter !important"
        >
          {props.customerDetails}
        </Typography>
      </Grid>
    </Grid>
  );
  return (
    <Box>
      {/* <Header title="Personal Details" /> */}
      <Paper
        sx={{
          margin: 'auto',
          // maxWidth: 500,
          flexGrow: 1,
        }}
      >
        <Grid container item xs={12} sm={12} md={12}>
          <Grid item xs={3} sm={3} md={3}>
            <Box
              sx={{
                padding: 2,
              }}
            >
              <Typography
                component="h5"
                variant="h5"
                color={colors.greenAccent[500]}
                fontWeight={800}
                fontSize={18}
                fontFamily="Inter !important"
                sx={{
                  textAlign: 'center',
                  marginBlock: 2,
                }}
              >
                {strings.displayText.profilePicture}
              </Typography>
              <Box marginBottom={5}></Box>
              <Box
                sx={{
                  alignSelf: 'center',
                  justifyContent: 'center',
                  alignItems: 'center',
                  display: 'flex',
                }}
              >
                {employeeInfo?.profileImage ? (
                  <Avatar
                    sx={{
                      height: '100px',
                      width: '100px',
                      alignSelf: 'center',
                      bgcolor: '#e4dfed',
                      color: '#202020',
                      fontWeight: 700,
                      fontSize: 40,
                    }}
                    alt="img"
                    src={image}
                  />
                ) : (
                  // <img src={image} />
                  <Avatar
                    sx={{
                      width: '100px',
                      height: '100px',
                      alignSelf: 'center',
                      bgcolor: '#B5DFC8',
                      color: '#202020',
                      fontFamily: 'Inter',
                      fontWeight: 700,
                      fontSize: 40,
                    }}
                  >
                    {employeeInfo?.firstName &&
                      employeeInfo?.firstName.slice(0, 1) +
                        employeeInfo?.lastName.slice(0, 1)}
                  </Avatar>
                )}
              </Box>
            </Box>
          </Grid>
          <Grid item xs={8} sm={8} md={8} sx={{ marginBlock: 2 }}>
            <Box marginTop={1}></Box>
            <ReuseGrid
              customName={strings.displayText.fullName}
              customerDetails={
                employeeInfo?.firstName
                  ? employeeInfo?.firstName + ' ' + employeeInfo?.lastName
                  : '-'
              }
            />
            <ReuseGrid
              customName={strings.displayText.emailAddress}
              customerDetails={employeeInfo?.email ? employeeInfo?.email : '-'}
            />
            <ReuseGrid
              customName={strings.displayText.phoneNumber}
              customerDetails={employeeInfo?.phone as string}
            />
            <Divider sx={{ marginBlock: 2 }} />
            <ReuseGrid
              customName={strings.displayText.desigination}
              customerDetails={
                employeeInfo?.designation ? employeeInfo?.designation : '-'
              }
            />
            <ReuseGrid
              customName={strings.displayText.department}
              customerDetails={
                employeeInfo?.department ? employeeInfo?.department : '-'
              }
            />
            <ReuseGrid
              customName={strings.displayText.location}
              customerDetails={
                employeeInfo?.location ? employeeInfo?.location : '-'
              }
            />
            <ReuseGrid
              customName={strings.displayText.employeeID}
              customerDetails={
                employeeInfo?.employeeId ? employeeInfo?.employeeId : '-'
              }
            />

            <Divider sx={{ marginBlock: 2 }} />
            <ReuseGrid
              customName={strings.displayText.startDate}
              customerDetails={
                employeeInfo?.startDate
                  ? dateFormat(employeeInfo?.startDate)
                  : '-'
              }
            />
            <ReuseGrid
              customName={strings.displayText.endDate}
              customerDetails={
                employeeInfo?.endDate ? employeeInfo?.endDate : '-'
              }
            />
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default PersonalDetails;
